import Loading from "components/center-loading";
import intl from "react-intl-universal";
import ProductionPlanSupplierFilter from "./components/production-plan-supplier-filter";
import ProductionPlanSupplierTable from "./components/production-plan-supplier-table";
import ProductionPlanSupplierUpload from "./components/production-plan-supplier-upload";
import { ProductionPlanSupplierProvider, useProductionPlanSupplierContext } from "./context";
import { Container, Content, Header, LoadingOverlay, TableSection, Title, Toolbar } from "./styled";

const ProductionPlanSupplier = () => {
  const { suppliers, loading, filterOptionsLoading } = useProductionPlanSupplierContext();

  return (
    <Container>
      <Header>
        <Title>{intl.get("productionPlanSupplier.title")}</Title>
      </Header>
      <Content>
        <Toolbar>
          <ProductionPlanSupplierFilter />
          <ProductionPlanSupplierUpload />
        </Toolbar>
        <TableSection>
          <ProductionPlanSupplierTable suppliers={suppliers} />
        </TableSection>
      </Content>
      {(loading || filterOptionsLoading) && (
        <LoadingOverlay>
          <Loading isLoading={loading || filterOptionsLoading} fullHeightParent />
        </LoadingOverlay>
      )}
    </Container>
  );
};

export { ProductionPlanSupplier, ProductionPlanSupplierProvider, useProductionPlanSupplierContext };
